import { Box } from '@mui/material';
import { node } from 'prop-types';
import React from 'react';

const FormsList = ({ children }) => (
  <Box sx={{ width: '100%', paddingTop: '20px' }}>{children}</Box>
);
FormsList.propTypes = {
  children: node.isRequired,
};

export default FormsList;
